import { gql } from '@apollo/client'
import { Modal, ModalProps, VisuallyHidden } from '@farol-ds/react'
import { ReactNode } from 'react'

import { useSendViewItemEvent } from '../../hooks/use-send-view-item-event'
import { useModalContext } from '../context'
import { ModalLock_OfferLockBodyFragment } from './__generated__/modal-lock.graphql'
import styles from './modal-lock.module.scss'

export interface ModalLockProps {
  children: ReactNode
  offerLockBody: ModalLock_OfferLockBodyFragment
  size?: ModalProps['size']
  footerContent?: ReactNode
  addHeader?: boolean
  title?: string
  showTitle?: boolean
}

export function ModalLock({
  children,
  footerContent,
  offerLockBody,
  size = 'md',
  addHeader = true,
  title,
  showTitle = false,
}: ModalLockProps) {
  const { open, setOpen } = useModalContext()
  const { sendViewItemRef } = useSendViewItemEvent({ offerLockBody })

  return (
    <Modal size={size} open={open} onOpenChange={setOpen}>
      <Modal.Content data-testid="modal-lock-content">
        {addHeader && (
          <>
            <Modal.IconClose data-testid="modal-lock-icon-close" />
            {showTitle && title ? (
              <div className={styles.customHeader} data-testid="modal-lock-header">
                <div className={styles.headerContent}>
                  <Modal.HeaderBrand
                    className={styles.headerBrand}
                    data-testid="modal-lock-header-brand"
                  />
                  <Modal.HeaderTitle asChild>
                    <h2 className={styles.modalTitle} data-testid="modal-lock-header-title">
                      {title}
                    </h2>
                  </Modal.HeaderTitle>
                </div>
              </div>
            ) : (
              <Modal.Header data-testid="modal-lock-header">
                <Modal.HeaderBrand data-testid="modal-lock-header-brand" />
              </Modal.Header>
            )}
          </>
        )}
        {!showTitle && (
          <VisuallyHidden>
            <Modal.HeaderTitle>{title || 'Assine o Jusbrasil'}</Modal.HeaderTitle>
          </VisuallyHidden>
        )}
        <Modal.Body
          data-testid="modal-lock-body"
          ref={sendViewItemRef}
          className={styles.modalBody}
        >
          {children}
        </Modal.Body>
        {footerContent && (
          <Modal.Footer data-testid="modal-lock-footer">{footerContent}</Modal.Footer>
        )}
      </Modal.Content>
    </Modal>
  )
}

ModalLock.fragments = {
  offerLockBody: gql`
    fragment ModalLock_offerLockBody on OfferLockBody {
      ...UseSendViewItemEvent_offerLockBody
    }

    ${useSendViewItemEvent.fragments.offerLockBody}
  `,
}
